import React, { useMemo, forwardRef } from "react";
import styles from './Input.module.css'
import cx from "classnames";

type InputProps = {
    type: 'text' | 'number' | 'password' | 'email' | 'url' | 'textarea';
    placeholder: string;
    property: string
    value: string | number;
    onChange: (property: string, value: any) => void;
    classes?: string;
    disabled?: boolean;
    maxLength?: number;
    style?: React.CSSProperties;
    withCount?: boolean;
    'data-option-field'?: string;
};

const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>((
    {
        type,
        placeholder,
        value,
        onChange,
        classes,
        disabled = false,
        property,
        style,
        maxLength,
        withCount = false,
        'data-option-field': dataOptionField
    }, ref
) => {

    const inputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (!maxLength || event.target.value.length <= maxLength) onChange(property, event.target.value)
    }

    const count = useMemo(() => {
        return (value + '').length
    }, [value])

    const hasValue = value !== '' && value !== undefined && value !== null && String(value).trim() !== '';

    return (
        <div className={cx(styles['zr-input-container'], classes)} style={style}>
            {type !== 'textarea' ?
                <>
                    <input
                        ref={ref as React.Ref<HTMLInputElement>}
                        type={type}
                        value={value}
                        onChange={inputChange}
                        placeholder={placeholder}
                        className={cx(styles['zr-input'], hasValue && styles['zr-input-filled'])}
                        disabled={disabled}
                        data-option-field={dataOptionField}
                    />
                    <label>{placeholder}</label>
                </>
                : <>
                    <textarea
                        ref={ref as React.Ref<HTMLTextAreaElement>}
                        value={value}
                        onChange={inputChange}
                        placeholder={placeholder}
                        className={cx(styles['zr-input'], hasValue && styles['zr-input-filled'])}
                        disabled={disabled}
                        maxLength={maxLength}
                        data-option-field={dataOptionField}
                    />
                    <label>{placeholder}</label>
                </>
            }
        </div>

    );
});

Input.displayName = 'Input';

export default Input;
